import React, { useEffect } from 'react';
import {
  Divider,
  Card,
  CardContent,
  CardHeader,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import Title from './Title';
import { fetchCooperations } from '../../actions';

const CooperationStatus = () => {
  const dispatch = useDispatch();

  const { cooperations } = useSelector((state) => state.dashboard);
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (user) {
      dispatch(fetchCooperations());
    }
  }, [dispatch, user]);

  const title = `협력사 현황(총 ${cooperations.length}개 업체)`;
  const unitDesc = '(단위: 명)';

  return (
    <Card sx={{ mb: 3 }}>
      <CardHeader title={<Title title={title} unitDesc={unitDesc} />} />
      <Divider />
      <CardContent>
        <TableContainer>
          <Table sx={{ borderTop: '1px solid rgba(224, 224, 224, 1)' }}>
            <TableBody>
              {cooperations.map((cooperation) => (
                <TableRow key={cooperation.id}>
                  <TableCell sx={{ backgroundColor: '#eeeeee', width: '50%' }}>
                    {cooperation.description}
                  </TableCell>
                  <TableCell>{cooperation.n_repeaters}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default CooperationStatus;
